import { $ as e, C as t, F as n, J as r, L as i, V as a, _ as o, f as s, h as c, i as l, l as u, m as d, nt as f, ot as p, p as m, q as h, rt as g, t as _, v, w as y, z as b } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as x } from "./i18n-lite-BcmwMblk.js";
import { t as S } from "./NavigationButton.ce-D8WGMxzc.js";
//#region src/webcomponents/pix-cursor/locales/de-AT.json
var C = {}, w = {}, T = {}, E = {}, D = { "pix-cursor": {
	confirm: "Valider",
	next: "Suivant",
	previous: "Précédent",
	selectAnOption: "Sélectionnez une option",
	youHaveChosen: "Vous avez choisi\xA0: {{ choice }}"
} }, O = { "pix-cursor": {
	confirm: "Valider",
	next: "Suivant",
	previous: "Précédent",
	selectAnOption: "Sélectionnez une option",
	youHaveChosen: "Vous avez choisi\xA0: {{ choice }}"
} }, k = {}, A = {}, j = ["for"], M = {
	class: "visible-options",
	"aria-hidden": "true"
}, N = ["onClick"], P = ["id"], F = [
	"value",
	"label",
	"onClick"
], I = [
	"id",
	"list",
	"max",
	"disabled"
], L = { class: "navigation-container" }, R = { class: "chosen-text-container" }, z = ["aria-hidden"], B = { class: "chosen-option" }, V = {
	class: "footer",
	"aria-live": "polite"
}, H = {
	key: 0,
	class: "confirm"
}, U = ["aria-hidden", "innerHTML"], W = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "PixCursor.ce",
	props: { options: { type: Array } },
	setup(l, { expose: _ }) {
		let y = l, x = e(Math.floor(y.options.length / 2)), C = e(!1), w = a(), T = a(), E = d(() => x.value === y.options.length - 1), D = d(() => x.value === 0), O = d(() => Number(x.value));
		function k() {
			C.value = !0;
		}
		function A() {
			C.value || (x.value = Math.max(0, O.value - 1));
		}
		function W() {
			C.value || (x.value = Math.min(y.options.length - 1, O.value + 1));
		}
		function G(e) {
			C.value || (x.value = e);
		}
		function K() {
			C.value = !1, x.value = Math.floor(y.options.length / 2);
		}
		return _({ reset: K }), (e, a) => {
			let d = b("i18n");
			return n(), v("form", {
				class: "pix-cursor",
				onSubmit: s(k, ["prevent"])
			}, [c("div", null, [
				c("label", {
					class: "sr-only",
					for: f(w)
				}, p(e.$t("pix-cursor.selectAnOption")), 9, j),
				c("ul", M, [(n(!0), v(m, null, i(l.options, (e, t) => (n(), v("li", {
					key: t,
					onClick: (e) => G(t)
				}, p(e.label), 9, N))), 128))]),
				c("datalist", { id: f(T) }, [(n(!0), v(m, null, i(l.options, (e, t) => (n(), v("option", {
					key: t,
					value: t,
					label: e.label,
					onClick: (e) => G(t)
				}, p(e.label), 9, F))), 128))], 8, P),
				r(c("input", {
					id: f(w),
					"onUpdate:modelValue": a[0] ||= (e) => x.value = e,
					type: "range",
					list: f(T),
					min: "0",
					max: l.options.length - 1,
					disabled: C.value
				}, null, 8, I), [[u, x.value]]),
				c("div", L, [
					t(S, {
						disabled: C.value || D.value,
						label: e.$t("pix-cursor.previous"),
						"aria-controls": f(w),
						"aria-disabled": C.value,
						"tooltip-position": "bottom",
						direction: "previous",
						type: "button",
						onClick: A
					}, null, 8, [
						"disabled",
						"label",
						"aria-controls",
						"aria-disabled"
					]),
					c("div", R, [(n(!0), v(m, null, i(l.options, (e, r) => (n(), v("p", {
						key: r,
						class: g({ hidden: r !== O.value }),
						"aria-hidden": r !== O.value
					}, [t(d, { t: "pix-cursor.youHaveChosen" }, {
						choice: h(() => [c("span", B, p(e.label), 1)]),
						_: 2
					}, 1024)], 10, z))), 128))]),
					t(S, {
						disabled: C.value || E.value,
						label: e.$t("pix-cursor.next"),
						"aria-controls": f(w),
						"aria-disabled": C.value,
						"tooltip-position": "bottom",
						direction: "next",
						type: "button",
						onClick: W
					}, null, 8, [
						"disabled",
						"label",
						"aria-controls",
						"aria-disabled"
					])
				])
			]), c("div", V, [C.value ? o("", !0) : (n(), v("button", H, p(e.$t("pix-cursor.confirm")), 1)), (n(!0), v(m, null, i(l.options, (e, t) => (n(), v("p", {
				key: t,
				class: g(["feedback", {
					[e.feedback.type]: !0,
					hidden: !C.value || O.value !== t
				}]),
				"aria-hidden": O.value !== t,
				innerHTML: e.feedback.text
			}, null, 10, U))), 128))])], 32);
		};
	}
}), [["styles", ["[data-v-733b8958]{--pix-neutral-800:#253858;color:var(--pix-neutral-800);font-family:Nunito,sans-serif}.pix-cursor[data-v-733b8958]{flex-direction:column;justify-content:center;gap:1rem;margin:auto;padding:2rem;display:flex;overflow:hidden}.pix-cursor p[data-v-733b8958]{text-align:center;font-size:1.1rem}.pix-cursor .chosen-option[data-v-733b8958]{font-weight:700}.pix-cursor .visible-options[data-v-733b8958]{justify-content:space-between;margin:0;padding:0;display:flex}.pix-cursor .visible-options li[data-v-733b8958]{cursor:pointer;list-style:none}.pix-cursor input[data-v-733b8958]{width:100%}.pix-cursor .confirm[data-v-733b8958]{cursor:pointer;letter-spacing:1.1px;color:#fff;background:#4075ff;border:none;border-radius:8px;grid-area:1/1;width:fit-content;margin:auto;padding:.75rem 1.5rem;font-size:1.25rem;font-weight:600}.pix-cursor .confirm[data-v-733b8958]:hover{background:#355ac4;transition:background .1s}.pix-cursor .navigation-container[data-v-733b8958]{justify-content:center;align-items:center;gap:1rem;display:flex}.pix-cursor .navigation-container .chosen-text-container[data-v-733b8958]{display:grid}.pix-cursor .navigation-container .chosen-text-container p[data-v-733b8958]{grid-area:1/1}.pix-cursor .navigation-container .chosen-text-container p.hidden[data-v-733b8958]{transform:translate(100vw)}.pix-cursor .footer[data-v-733b8958]{grid-template-columns:auto;justify-content:center;align-items:center;display:grid}.pix-cursor .feedback[data-v-733b8958]{text-align:start;border-left:4px solid;border-radius:8px;grid-area:1/1;margin:0;padding:1rem 1.2rem}.pix-cursor .feedback.hidden[data-v-733b8958]{visibility:hidden;transform:translate(100vw)}.pix-cursor .feedback.good[data-v-733b8958]{background:#e8f5e9;border-left-color:#4caf51}.pix-cursor .feedback.bad[data-v-733b8958]{background:#ffebee;border-left-color:#f44337}.pix-cursor .feedback.neutral[data-v-733b8958]{background:#e8f6ff;border-left-color:#464ee0}.pix-cursor .feedback.close[data-v-733b8958]{background:#fff8e1;border-left-color:#ffc108}"]], ["__scopeId", "data-v-733b8958"]]);
x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": C,
	"./locales/en.json": w,
	"./locales/es-419.json": T,
	"./locales/es.json": E,
	"./locales/fr-BE.json": D,
	"./locales/fr.json": O,
	"./locales/it.json": k,
	"./locales/nl.json": A
})), window.customElements.define("pix-cursor", l(W, { configureApp(e) {
	x.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(x);
} }));
//#endregion
